import { render } from "./PaymentRegister.vue?vue&type=template&id=a4895e8c"
import script from "./PaymentRegister.vue?vue&type=script&lang=js"
export * from "./PaymentRegister.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__